import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { voucherSchema } from '../types';

export const createGetVoucherQuery = () =>
	createAuthQuery({
		params: declareParams<number>(),
		request: {
			method: 'GET',
			url: (id) => `/voucher/${id}`,
		},
		response: {
			contract: zodContract(voucherSchema),
		},
	});
